//Contains custom data for our instrumentation amplifiers.  Because in-amps have unique structures that require additional curve-fitting by the modelers, this file is 
// used to store and edit the data without fear of it being overwritten by the python automation script which overwrites the in-amp-tpc-database.js file.  The data in 

import { PIN_NAMES } from "../sim-constants";

// this file should be elements that are not readily discerned from the datasheet (i.e. table data or plots should be in the pdb-database & tpc-database files, respectively)
export let data = {
    "map": {
        "AD620": "AD620",           
        "AD621": "AD621",           
        "AD622": "AD622",
        "AD623": "AD623",
        "AD8220": "AD8220",
        "AD8221": "AD8221",
        "AD8222": "AD8222",
        "AD8223": "AD8223",
        "AD8224": "AD8224",
        "AD8226": "AD8226",
        "AD8227": "AD8227",
        "AD8228": "AD8228",
        "AD8229": "AD8229",
        "AD8229S": "AD8229",                //AD8229S is space grade version of AD8229 - need to revisit when we do DC specs
        "AD8235": "AD8235_AD8236",
        "AD8236": "AD8235_AD8236",
        "AD8250": "AD8250",
        "AD8251": "AD8251",
        "AD8253": "AD8253",
        "AD8295": "AD8295",                 
        "AD8421": "AD8421",
        "AD8422": "AD8422",
        "AD8426": "AD8426",
        "AD8429": "AD8429",
        "LT1167": "LT1167_LT1167-1",
        "LT1167-1": "LT1167_LT1167-1",
        "LT6370" : "LT6370",
        "LT6372-0.2": "LT6372-0.2",         // No data in TPC database, will not be allowed
        "LT6372-1": "LT6372-1",             // No data in TPC database, will not be allowed
        "LTC6373": "LTC6373",
        "MAX41400" : "MAX41400",
        "ADA4254": "ADA4254",
        "ADA4255": "ADA4255",
        "AD8428": "AD8428",             
    },
    "partData": {

        "AD620": {
            "inputStage" : {
                "gbwMax" : 9.55e6,
                "gbwMin" : 1.26e6,
                "gmMin"  : 1.74e-4,
                "rF"     : 50000,
                "cF"     : 0,
                "cDiff"  : 3.63e-12,
                "cCm"    : 1.05e-12,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        2.75e5,
                        8.71e6
                    ],
                    "zeros": [
                        6.61e5
                    ]
                }
            },
            "outputStage": {
                "rF"    : 10000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        5.75e+00,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD621": {
            "inputStage" : {
                "gains (V/V)" : [
                    "100",
                    "10",
                ],
                "cDiff": 5e-11, 
                "cCm":   2e-12, 
                "rDiff": 10e9, 
                "rCm":   10e9,
                "100" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain":140,
                        "poles": [
                            1.26e+00,
                            3.16e+05,
                            7.94e+05,
                        ],
                        "zeros": [
                            5.25e+05,
                        ],

                    },
                    "r1" : 25e3,
                    "r2" : 25e3,
                    "r3" : 5.05e+2,
                    "cF" : 1e-15, 
                },
                "10": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            4.13e-1,
                            3.16e+05,
                            7.94e+05,
                        ],
                        "zeros": [
                            5.25e5,
                        ],

                    },
                    "r1" : 25e3,
                    "r2" : 25e3,
                    "r3" : 5.56e3,
                    "cF" : 1e-15
                },

            },
            "outputStage" : {
            "cDiff" : 0.4e-10,
            "cCm" : 1.5e-12, 
            "rDiff" : 5.3e9,
            "rCm" : 2.5e9,
            "openLoopGain": {
                "dataFormat": "pole zero",
                "xUnits": "Hz",
                "yUnits": "Db, Degrees",
                "dcGain": 120,
                "poles": [
                    2e0,
                    7.94e5,
                    6.31e6,
                ],
                "zeros": [
                    1.20e+05,
                ],

            },
            
            "cf" : 1.15e-12,
            "r1" : 10e3,
            "r2" : 10e3,
            "r3" : 10e3,
            "r4" : 10e3
            },
        },
        "AD622": { //data copied from AD8221
            "inputStage" : {
                "gbwMax" : 1.32e7,
                "gbwMin" : 8.71e5,
                "gmMin"  : 7.59e-5,
                "rF"     : 49400,
                "cF"     : 0,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        6.92e5,
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 10000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        2.00e+00,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD623": {
            "inputStage" : {
                "gbwMax" : 1.32e6,
                "gbwMin" : 8.71e5,
                "gmMin"  : 1e-4,
                "rF"     : 100000,
                "cF"     : 0,
                "cDiff"  : 2.29e-12,
                "cCm"    : 5.75e-12,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 50000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 6e-13,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        5.50e-01,
                        1.66e+06,
                    ],
                    "zeros": [
                    ]
                }
            }, 
        },
        "AD8220": {
            "inputStage" : {
                "gbwMax" : 1.45e7,
                "gbwMin" : 2.40e6,
                "gmMin"  : 9.12e-5,
                "rF"     : 49400,
                "cF"     : 0,
                "cDiff"  : 0,
                "cCm"    : 3e-12,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 20000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        1.51e+00,
                        3.31e+06,
                        4.37e+06,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8221": {
            "inputStage" : {
                "gbwMax" : 1.32e7,
                "gbwMin" : 8.71e5,
                "gmMin"  : 7.59e-5,
                "rF"     : 49400,
                "cF"     : 0,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        6.92e5,
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 10000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        2.00e+00,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8222": {
            "inputStage" : {
                "gbwMax" : 1.32e7,
                "gbwMin" : 1e6,
                "gmMin"  : 7.94e-5,
                "rF"     : 49400,
                "cF"     : 0,
                "cDiff"  : 2.88e-12,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        1e6
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 10000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        2.75e+00,
                        2.75e+06,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8223": {
            "inputStage" : {
                "gbwMax" : 1.66e6,
                "gbwMin" : 1e10,
                "gmMin"  : 1e-4,
                "rF"     : 16000,
                "cF"     : 0,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        2.19e6
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 50000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        1.05e+00,
                        2.19e+06,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8224": { //data copied from AD8220
            "inputStage" : {
                "gbwMax" : 1.45e7,
                "gbwMin" : 2.40e6,
                "gmMin"  : 9.12e-5,
                "rF"     : 49400,
                "cF"     : 0,
                "cDiff"  : 0,
                "cCm"    : 3e-12,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 20000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        1.51e+00,
                        3.31e+06,
                        4.37e+06,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8226": {
            "inputStage" : {
                "gbwMax" : 2.19e6,
                "gbwMin" : 1.66e6,
                "gmMin"  : 0.0347,
                "rF"     : 49400,
                "cF"     : 0,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 50000,
                "cF"    : 2.00e-12,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        3.80e+00,
                        1.66e+06,
                        5.01e+06,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8227": {
            "inputStage" : {
                "gbwMax" : 1.05e6,
                "gbwMin" : 1e10,
                "gmMin"  : 3e-5,
                "rF"     : 16000,
                "cF"     : 0,
                "cDiff"  : 3.31e-12,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        1.20e6,
                        1.32e6,
                        2.51e6,
                        4.57e6,
                    ],
                    "zeros": [
                        5.25e5,
                        8.32e5,
                        1.15e7
                    ]
                }
            },
            "outputStage": {
                "rF"    : 50000,
                "cF"    : 1.32e-12,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        1.51e+00,
                        3.02e+06,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8228": {
            "inputStage" : {
                "gains (V/V)" : [
                    "100",
                    "10",
                ],
                "cDiff": 1e-15, 
                "cCm":   1e-15, 
                "rDiff": 10e9, 
                "rCm":   10e9,
                "100" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain":140,
                        "poles": [
                            1.31,
                            4.79e+05,
                            3.16e6
                        ],
                        "zeros": [
                            1.26e6,
                            1.45e6,
                        ],

                    },
                    "r1" : 22e3,
                    "r2" : 22e3,
                    "r3" : 4.45e+2,
                    "cF" : 6.03e-12, 
                },
                "10": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            0.84,
                            4.79e+05,
                            3.16e6
                        ],
                        "zeros": [
                            1.26e6,
                            1.45e6,
                        ],

                    },
                    "r1" : 25e3,
                    "r2" : 25e3,
                    "r3" : 4.89e3,
                    "cF" : 6.03e-12
                },

            },
            "outputStage" : {
            "cDiff" : 9.12e-12,
            "cCm" : 3.63e-12, 
            "rDiff" : 5.3e9,
            "rCm" : 2.5e9,
            "openLoopGain": {
                "dataFormat": "pole zero",
                "xUnits": "Hz",
                "yUnits": "Db, Degrees",
                "dcGain": 120,
                "poles": [
                    3.02e0,
                    3.47e5,
                    6.31e6,
                ],
                "zeros": [
                    7.59e+05,
                    2.63e+06
                ],

            },
            
            "cF" : 1e-15,
            "r1" : 10e3,
            "r2" : 10e3,
            "r3" : 10e3,
            "r4" : 10e3
            },
        },
        "AD8229": {
            "inputStage" : {
                "gbwMax" : 1.58e8,
                "gbwMin" : 1.82e7,
                "gmMin"  : 0.00191,
                "rF"     : 6000,
                "cF"     : 3.00e-12,
                "cDiff"  : 5.50e-12,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        2.75e7,
                        7.24e7
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 5000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        1.51e+01,
                        3.31e+07,
                        3.47e+07,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8235_AD8236": {
            "opAmp" : 'AD8505',
            "rg1"   : 210e3,
            "rf1"   : 52.5e3,
            "rg2"   : 52.5e3,
            "rf2"   : 210e3
        },
        "AD8250" : {
            "emiFilter" : {
                "r"     : 2.2e3,
                "cCm"   : 0,
                "cDiff" : 0
            },
            "inputStage" : {
                "gains (V/V)" : [
                    "10",
                    "5",
                    "2",
                    "1",
                ],
                "cDiff": 0.5e-12, 
                "cCm":   1e-12, 
                "rDiff": 5.3e9, 
                "rCm":   2.5e9, 
                "10" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 119,
                        "poles": [
                            4.26e+01,
                            3.00e+07,
                            1.00e+08,
                            1.00e+08,
                        ],
                        "zeros": [
                            2.00e+07,
                        ],
                    },
                    "r1" : 4.5e3,
                    "r2" : 4.5e3,
                    "r3" : 1e3,
                    "cF" : 1.5e-12
                },
                "5": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 119,
                        "poles": [
                            6.16e+01,
                            3.00e+07,
                        ],
                        "zeros": [
                            2.00e+07,
                        ],
                    },
                    "r1" : 4e3,
                    "r2" : 4e3,
                    "r3" : 2e3,
                    "cF" : 1.5e-12
                },
                "2": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 119,
                        "poles": [
                            3.54e+01,
                            1.50e+07,
                            1.00e+08,
                            1.00e+08,
                        ],
                        "zeros": [
                            2.00e+07,
                        ],
                    },
                    "r1" : 2.5e3,
                    "r2" : 2.5e3,
                    "r3" : 5e3,
                    "cF" : 1.5e-12
                },
                "1": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 119,
                        "poles": [
                            1.12e+02,
                        ],
                        "zeros": [
                        ],
                    },
                    "r1" : 1e-3,
                    "r2" : 1e-3,
                    "r3" : 10e3,
                    "cF" : 1.5e-12
                },
            },
            "outputStage" : {
                "cDiff" : 0.5e-12,
                "cCm" : 1.5e-12, 
                "rDiff" : 5.3e9,
                "rCm" : 2.5e9,
                "openLoopGain": {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 159,
                    "poles": [
                        2.56e-01,
                        6.00e+07,
                        1.00e+08,
                        1.00e+08,
                    ],
                    "zeros": [
                        3.16e+07,
                    ],
                },
                "r1" : 10e3,
                "r2" : 10e3,
                "r3" : 10e3,
                "r4" : 10e3
            },
        },
        "AD8251" : {
            "emiFilter" : {
                "r"     : 2.2e3,
                "cCm"   : 0,
                "cDiff" : 0
            },
            "inputStage" : {
                "gains (V/V)" : [
                    "8",
                    "4",
                    "2",
                    "1",
                ],
                "cDiff": 0.5e-12, 
                "cCm":   1e-12, 
                "rDiff": 5.3e9, 
                "rCm":   2.5e9,
                "8" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 119,
                        "poles": [
                            2.95e+01,
                            3.00e+07,
                            1.00e+08,
                            1.00e+08,
                        ],
                        "zeros": [
                            2.00e+07,
                        ],
                    },
                    "r1" : 3.5e3,
                    "r2" : 3.5e3,
                    "r3" : 1e3,
                    "cF" : 1.5e-12, 
                },
                "4": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 119,
                        "poles": [
                            4.00e+01,
                            6.00e+07,
                            1.00e+08,
                            1.00e+08,
                        ],
                        "zeros": [
                            2.00e+07,
                        ],
                    },
                    "r1" : 3e3,
                    "r2" : 3e3,
                    "r3" : 2e3,
                    "cF" : 1.5e-12
                },
                "2": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 119,
                        "poles": [
                            5.62e+01,
                            1.00e+08,
                            1.00e+08,
                        ],
                        "zeros": [
                            3.00e+07,
                        ],
                    },
                    "r1" : 2e3,
                    "r2" : 2e3,
                    "r3" : 4e3,
                    "cF" : 1.5e-12
                },
                "1": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 119,
                        "poles": [
                            5.62e+01,
                            6.00e+07,
                            1.00e+08,
                            1.00e+08,
                        ],
                        "zeros": [
                            3.00e+07,
                        ],
                    },
                    "r1" : 1e-3,
                    "r2" : 1e-3,
                    "r3" : 8e3,
                    "cF" : 1.5e-12
                },
            },
            "outputStage" : {
                "cDiff" : 0.5e-12,
                "cCm" : 1.5e-12, 
                "rDiff" : 5.3e9,
                "rCm" : 2.5e9,
                "gains (V/V)" : [
                    "8",
                    "4",
                    "2",
                    "1",
                ],  
                "8" : {   
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 159,
                        "poles": [
                            1.90e-01,
                            6.00e+07,
                            1.00e+08,
                            1.00e+08,
                        ],
                        "zeros": [
                            4.00e+07,
                        ],
                    },
                    "r1" : 10e3,
                    "r2" : 10e3,
                    "r3" : 10e3,
                    "r4" : 10e3
                },
                "4" : {   
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 159,
                        "poles": [
                            1.90e-01,
                            6.00e+07,
                            1.00e+08,
                            1.00e+08,
                        ],
                        "zeros": [
                            4.00e+07,
                        ],
                    },
                    "r1" : 10e3,
                    "r2" : 10e3,
                    "r3" : 10e3,
                    "r4" : 10e3
                },
                "2" : {   
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 159,
                        "poles": [
                            1.90e-01,
                            6.00e+07,
                            1.00e+08,
                            1.00e+08,
                        ],
                        "zeros": [
                            4.00e+07,
                        ],
                    },
                    "r1" : 10e3,
                    "r2" : 10e3,
                    "r3" : 10e3,
                    "r4" : 10e3
                },
                "1" : {   
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 159,
                        "poles": [
                            2.57e-01,
                            6.00e+07,
                            1.00e+08,
                            1.00e+08,
                        ],
                        "zeros": [
                            4.00e+07,
                        ],
                    },
                    "r1" : 10e3,
                    "r2" : 10e3,
                    "r3" : 10e3,
                    "r4" : 10e3,
                    "cF" : 2.75e-13
                }
            },
        },
        "AD8253" : {
            "emiFilter" : {
                "r"     : 1.2e3,
                "cCm"   : 0,
                "cDiff" : 0
            },
            "inputStage" : {
                "gains (V/V)" : [
                    "1000",
                    "100",
                    "10",
                    "1",
                ],
                "cDiff": 1.25e-12, 
                "cCm":   2.5e-12, 
                "rDiff": 4e9, 
                "rCm":   2e9,
                "1000" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120, 
                        "poles": [
                            7.00e+01,
                            1.30e+08,
                            1.30e+08,
                            2.00e+08,
                        ],
                        "zeros": [
                            6.50e+07,
                        ],
                    },
                    "r1" : 49.95e3,
                    "r2" : 49.95e3,
                    "r3" : 100,
                    "cF" : 1.5e-12, 
                },
                "100": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            6.30e+01,
                            1.30e+08,
                            1.30e+08,
                            2.00e+08,
                        ],
                        "zeros": [
                            6.50e+07,
                        ],
                    },
                    "r1" : 19.8e3,
                    "r2" : 19.8e3,
                    "r3" : 400,
                    "cF" : 1.5e-12
                },
                "10": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            4.80e+01,
                            2.00e+08,
                            2.00e+08,
                            2.00e+08,
                        ],
                        "zeros": [
                            6.50e+07,
                        ],
                    },
                    "r1" : 6.75e3,
                    "r2" : 6.75e3,
                    "r3" : 1.5e3,
                    "cF" : 1.5e-12
                },
                "1": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            8.70e+00,
                            2.00e+08,
                            2.30e+08,
                            2.30e+08,
                        ],
                        "zeros": [
                            2.50e+07,
                        ],
                    },
                    "r1" : 1e-3,
                    "r2" : 1e-3,
                    "r3" : 100e3,
                    "cF" : 1.5e-12
                },
            },
            "outputStage" : {
                "cDiff" : 1.25e-12,
                "cCm" : 1e-15,
                "rDiff" : 4e9,
                "rCm" : 2e9,
                "openLoopGain": {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 159,
                    "poles": [
                        2.40e-01,
                        6.00e+07,
                        1.00e+08,
                        1.00e+08,
                    ],
                    "zeros": [
                        4.00e+07,
                    ],
                },
                "r1" : 10e3,
                "r2" : 10e3,
                "r3" : 10e3,
                "r4" : 10e3
            },
        },
        "AD8295": {
            "inputStage" : {
                "gbwMax" : 1.32e7,
                "gbwMin" : 8.32e5,
                "gmMin"  : 7.59e-5,
                "rF"     : 49400,
                "cF"     : 0,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        1.38e6,
                        1.38e6,
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 10000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        1.05e+01,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8421": {
            "inputStage" : {
                "gbwMax" : 2.09e8,
                "gbwMin" : 1e10,
                "gmMin"  : 1,
                "rF"     : 9900,
                "cF"     : 1.9e-12,
                "cDiff"  : 2.19e-11,
                "cCm"    : 3.63e-12,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 10000,
                "cF"    : 0,
                "cDiff" : 1.45e-12,
                "cCm"   : 1.05e-12,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        1.58e+01,
                        3.31e+07,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8422": {
            "inputStage" : {
                "gbwMax" : 1.32e7,
                "gbwMin" : 8.71e6,
                "gmMin"  : 2.63e-2,
                "rF"     : 19800,
                "cF"     : 0,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 10000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        2.75e+00,
                        2.75e+06,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "AD8426": {
            "inputStage" : {
                "gbwMax" : 2.00e6,
                "gbwMin" : 6.03e5,
                "gmMin"  : 2.51e-4,
                "rF"     : 49400,
                "cF"     : 0,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        2.09e6,
                        2.63e6
                    ],
                    "zeros": [
                        2.88e6
                    ]
                }
            },
            "outputStage": {
                "rF"    : 50000,
                "cF"    : 1.74e-12,
                "cDiff" : 2.40e-12,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        9.12e+00,
                        1.00e+06,
                    ],
                    "zeros": [
                        2.51e6
                    ]
                }
            },
        },
        "AD8428": {
            "inputStage" : {
                "gains (V/V)" : [
                    "2000",
                    
                ],
                //Values taken from the part's data sheet, then cCm is halved and rCm  is doubled to acount for the two input opamps in parallel
                "cDiff": 1e-12, 
                "cCm":   2e-12, 
                "rDiff": 2e9, 
                "rCm":   1e9,
                "2000": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            575,
                            8.32e6,
                        ],
                        "zeros":[

                        ]
                        
                    },
                    "r1" : 3e3,
                    "r2" : 3e3,
                    "r3" : 30.15,
                    "cF" : 1.5e-12
                },
            },
            "outputStage" : {

                "cDiff" : 1e-15,
                "cCm" : 1e-15,//cCm changed from 2.5pF to 1fF to better match AD8253's gain vs frequency response in Nimble to its datasheet.
                "rDiff" : 1e20,
                "rCm" : 1e20,
            
                "openLoopGain": {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        38,
                        4.17e6,
                        
                    ],
                    "zeros":[
                        
                    ]

                },
            
                "r1" : 12e3,
                "r2" : 120e3,
                "r3" : 12e3,
                "r4" : 120e3,
                "cF" : 5.01e-14
            },
        },
        "AD8429": { //data copied from AD8229
            "inputStage" : {
                "gbwMax" : 1.58e8,
                "gbwMin" : 1.82e7,
                "gmMin"  : 0.00191,
                "rF"     : 6000,
                "cF"     : 3.00e-12,
                "cDiff"  : 5.50e-12,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        2.75e7,
                        7.24e7
                    ],
                    "zeros": [
                    ]
                }
            },
            "outputStage": {
                "rF"    : 5000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        1.51e+01,
                        3.31e+07,
                        3.47e+07,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "ADA4254": {
            //The ADA4254 is so unique that all its data is stored within its code.  If we create
            //future parts with the same architecture, data should be pulled out to here. 
            //Hopefully lint doesn't get grumpy about this.

            // Had to break the above comment because the required supply pins looks specifically in custom data
            requiredSupplyPins: [
                PIN_NAMES.IN_AMP.SUPPLY_POS,
                PIN_NAMES.IN_AMP.SUPPLY_NEG,
                PIN_NAMES.IN_AMP.SUPPLY_INPUT_POS,
                PIN_NAMES.IN_AMP.SUPPLY_INPUT_NEG,
            ]
        },
        "ADA4255": {
            //The ADA4255 is so unique that all its data is stored within its code.  If we create
            //future parts with the same architecture, data should be pulled out to here. 
            //Hopefully lint doesn't get grumpy about this.
            
            // Had to break the above comment because the required supply pins looks specifically in custom data
            requiredSupplyPins: [
                PIN_NAMES.IN_AMP.SUPPLY_POS,
                PIN_NAMES.IN_AMP.SUPPLY_NEG,
                PIN_NAMES.IN_AMP.SUPPLY_CP_POS,
                PIN_NAMES.IN_AMP.SUPPLY_DIGITAL_POS,
                PIN_NAMES.IN_AMP.SUPPLY_DIGITAL_NEG,
            ]
        },
        "LT1167_LT1167-1": {
            "inputStage" : {
                "gbwMax" : 1.20e7,
                "gbwMin" : 7.94e5,
                "gmMin"  : 1.20e-4,
                "rF"     : 49400,
                "cF"     : 0,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        3.16e5,
                        5.50e6,
                    ],
                    "zeros": [
                        1.5e6,
                    ]
                }
            },
            "outputStage": {
                "rF"    : 10000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        1.91e+00,
                        1.5e+06,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "LT6370" : {
            "inputStage" : {
                "gbwMax" : 1.32e7,
                "gbwMin" : 2.75e6,
                "gmMin"  : 1.00e-4,
                "rF"     : 24200,
                "cF"     : 5.50e-12,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        7.24e6,
                        9.12e6,
                    ],
                    "zeros": [
                        2.00e7,      // added after curve-fitting to make input stage net 2 poles (3 poles / 1 zero)
                    ]
                }
            },
            "outputStage": {
                "rF"    : 10000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        5.50e+00,
                        1.05e+07,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "LT6372-0.2" : {
            "inputStage" : {
                "gbwMax" : 1.32e7,
                "gbwMin" : 2.75e6,
                "gmMin"  : 1.00e-4,
                "rF"     : 24200,
                "cF"     : 5.50e-12,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        7.24e6,
                        9.12e6,
                    ],
                    "zeros": [
                        2.00e7,      // added after curve-fitting to make input stage net 2 poles (3 poles / 1 zero)
                    ]
                }
            },
            "outputStage": {
                "rF"    : 2000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        5.50e+00,
                        1.05e+07,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "LT6372-1" : { //data copied from LT6370
            "inputStage" : {
                "gbwMax" : 1.32e7,
                "gbwMin" : 2.75e6,
                "gmMin"  : 1.00e-4,
                "rF"     : 24200,
                "cF"     : 5.50e-12,
                "cDiff"  : 0,
                "cCm"    : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 140,
                    "poles": [
                        // Dominant pole calculated in model,
                        7.24e6,
                        9.12e6,
                    ],
                    "zeros": [
                        2.00e7,      // added after curve-fitting to make input stage net 2 poles (3 poles / 1 zero)
                    ]
                }
            },
            "outputStage": {
                "rF"    : 10000,
                "cF"    : 0,
                "cDiff" : 0,
                "cCm"   : 0,
                "openLoopGain" : {
                    "dataFormat": "pole zero",
                    "xUnits": "Hz",
                    "yUnits": "Db, Degrees",
                    "dcGain": 120,
                    "poles": [
                        5.50e+00,
                        1.05e+07,
                    ],
                    "zeros": [
                    ]
                }
            },
        },
        "LTC6373" : {
            "inputStage" : {
                "gains (V/V)" : [
                    "16",
                    "8",
                    "4",
                    "2",
                    "1",
                    "0.5",
                    "0.25"
                ],
                "cDiff": 1e-15, 
                "cCm":   1.6e-12, 
                "rDiff": 5e12, 
                "rCm":   5e12, 
                "supplyCurrentTyp" : 0.6e-3,        // Iq/amp
                // "rOut":  110,
                "16" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 128,
                        "poles": [
                            2.40e+01,
                            3.80e+06,
                            3.80e+06,
                            3.00e+07,
                            3.00e+07,
                        ],
                        "zeros": [
                            1.26e+07,
                        ],
                    },
                    "r1" : 1.875e3,
                    "r2" : 1.875e3,
                    "r3" : 250,
                    "cF" : 2.63e-11
                },
                "8" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 128,
                        "poles": [
                            1.58e+01,
                            3.00e+06,
                            1.82e+07,
                            1.82e+07,
                        ],
                        "zeros": [
                            7.24e+07,
                        ],
                    },
                    "r1" : 1.75e3,
                    "r2" : 1.75e3,
                    "r3" : 500,
                    "cF" : 1.05e-11
                },
                "4" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 128,
                        "poles": [
                           9.55e+00,
                           3.00e+06,
                           1.82e+07,
                           1.82e+07,
                        ],
                        "zeros": [
                             7.24e+07,
                        ],
                    },
                    "r1" : 1.5e3,
                    "r2" : 1.5e3,
                    "r3" : 1e3,
                    "cF" : 1.26e-11
                },
                "2" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 128,
                        "poles": [
                           4.78e+00,
                           3.31e+06,
                           1.45e+07,
                           1.45e+07,
                        ],
                        "zeros": [
                             1.15e+07,
                        ],
                    },
                    "r1" : 1e3,
                    "r2" : 1e3,
                    "r3" : 2e3,
                    "cF" : 8e-12
                },
                "1" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 128,
                        "poles": [
                            2.40e+00,
                            3.00e+06,
                        ],
                        "zeros": [
                        ],
                    },
                    "r1" : 1e-3,
                    "r2" : 1e-3,
                    "r3" : 4e3,
                    "cF" : 8e-12
                },
                "0.5" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 128,
                        "poles": [
                             2.51e+00,
                             3.00e+06,
                        ],
                        "zeros": [
                        ],
                    },
                    "r1" : 1e-3,
                    "r2" : 1e-3,
                    "r3" : 4e3,
                    "cF" : 8e-12
                },
                "0.25" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 128,
                        "poles": [
                            2.63e+00,
                            3.16e+06,
                        ],
                        "zeros": [
                        ],
                    },
                    "r1" : 1e-3,
                    "r2" : 1e-3,
                    "r3" : 4e3,
                    "cF" : 8e-12
                }
            },
            "outputStage" : {
                // "rOutParasitic" : 1,
                "gbwCm":    1e6, 
                "rInVocm":  2.3e6, 
                "cDiff":    2.75e-12, 
                "cCm":      1e-15, 
                "rDiff":    5e12, 
                "rCm":      5e12, 
                // "rOut":     500,
                "vNoise":   0,
                "vNoiseVocm":   24e-9,
                "supplyCurrentTyp" : 3.2e-3,
                "gains (V/V)" : [
                    "16",
                    "8",
                    "4",
                    "2",
                    "1",
                    "0.5",
                    "0.25"
                ],
                "16" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            3.63e+00,
                            1.10e+07,
                        ],
                        "zeros": [
                            2.75e+07,
                        ],
                    },
                    "r1" : 2e3,
                    "r2" : 2e3,
                    "r3" : 2e3,
                    "r4" : 2e3,
                    "cF" : 1e-15
                },
                "8" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            3.63e+00,
                            1.10e+07,
                        ],
                        "zeros": [
                            2.75e+07,
                        ],
                    },
                    "r1" : 2e3,
                    "r2" : 2e3,
                    "r3" : 2e3,
                    "r4" : 2e3,
                    "cF" : 1e-15
                },
                "4" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            3.63e+00,
                            1.10e+07,
                        ],
                        "zeros": [
                            2.75e+07,
                        ],
                    },
                    "r1" : 2e3,
                    "r2" : 2e3,
                    "r3" : 2e3,
                    "r4" : 2e3,
                    "cF" : 1e-15
                },
                "2" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            3.63e+00,
                            1.10e+07,
                        ],
                        "zeros": [
                            2.75e+07,
                        ],
                    },
                    "r1" : 2e3,
                    "r2" : 2e3,
                    "r3" : 2e3,
                    "r4" : 2e3,
                    "cF" : 1e-15
                },
                "1" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            3.63e+00,
                            1.10e+07,
                        ],
                        "zeros": [
                            1.26e+08,
                        ],
                    },
                    "r1" : 2e3,
                    "r2" : 2e3,
                    "r3" : 2e3,
                    "r4" : 2e3,
                    "cF" : 1e-15
                },
                "0.5" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            3.63e+00,
                            7.94e+06,
                        ],
                        "zeros": [
                            6.00e+07,
                        ],
                    },
                    "r1" : 8e3 / 3,
                    "r2" : 4e3 / 3,
                    "r3" : 8e3 / 3,
                    "r4" : 4e3 / 3,
                    "cF" : 1e-15
                },
                "0.25" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            3.63e+00,
                            6.31e+06,
                        ],
                        "zeros": [
                            6.00e+07,
                        ],
                    },
                    "r1" : 3.2e3,
                    "r2" : 800,
                    "r3" : 3.2e3,
                    "r4" : 800,
                    "cF" : 1e-15
                }
            },
            "requiredSupplyPins" : [
                PIN_NAMES.IN_AMP.SUPPLY_POS,
                PIN_NAMES.IN_AMP.SUPPLY_NEG,
                PIN_NAMES.IN_AMP.SUPPLY_INPUT_POS,
            ]
        },
        "MAX41400" : {
            "requiredPDBParameters" : [],
            "emiFilter" : {
                "r"     : 2e3,
                "cCm"   : 5e-12,
                "cDiff" : 0
            },
            "inputStage" : {
                "gains (V/V)" : [
                    "250",
                    "200",
                    "150",
                    "100",
                    "80",
                    "40",
                    "20",
                    "10"
                ],
                "250" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            7.60e-03,
                            1.20e+05,
                        ],
                        "zeros": [
                        ],
                    },
                    "r1" : 55.2e3,
                    "r2" : 55.2e3,
                    "r3" : 4.6e3,
                },
                "200": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            7.60e-03,
                            1.20e+05,
                        ],
                        "zeros": [
                        ],
                    },
                    "r1" : 54.625e3,
                    "r2" : 54.625e3,
                    "r3" : 5.75e3,
                },
                "150": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            7.60e-03,
                            1.20e+05,
                        ],
                        "zeros": [
                        ],
                    },
                    "r1" : 161e3/3,
                    "r2" : 161e3/3,
                    "r3" : 23e3/3,
                },
                "100": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            1.05e-02,
                            5.50e+03,
                            1.00e+05,
                            1.00e+05,
                            1.00e+05,
                        ],
                        "zeros": [
                            8.71e+03,
                        ],
                    },
                    "r1" : 51.75e3,
                    "r2" : 51.75e3,
                    "r3" : 11.5e3,
                },
                "80": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            1.05e-02,
                            5.50e+03,
                            1.00e+05,
                            1.00e+05,
                            1.00e+05,
                        ],
                        "zeros": [
                            8.71e+03,
                        ],
                    },
                    "r1" : 50.3125e3,
                    "r2" : 50.3125e3,
                    "r3" : 14.375e3,
                },
                "40": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            5.01e-02,
                        ],
                        "zeros": [
                        ],
                    },
                    "r1" : 54.625e3,
                    "r2" : 54.625e3,
                    "r3" : 5.75e3,
                },
                "20": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            5.01e-02,
                        ],
                        "zeros": [
                        ],
                    },
                    "r1" : 51.75e3,
                    "r2" : 51.75e3,
                    "r3" : 11.5e3,
                },
                "10": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 140,
                        "poles": [
                            2.19e-02,
                        ],
                        "zeros": [
                        ],
                    },
                    "r1" : 46e3,
                    "r2" : 46e3,
                    "r3" : 23e3,
                },
            },
            "outputStage" : {
                "slewRate" : 0.08e6,
                "gains (V/V)" : [
                    "250",
                    "200",
                    "150",
                    "100",
                    "80",
                    "40",
                    "20",
                    "10"
                ],     
                "250" : {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            8.00e-01,
                            4.40e+04,
                            8.00e+05,
                        ],
                        "zeros": [
                            2.40e+05,
                        ],
                    },
                    "r1" : 81.818e3,
                    "r2" : 818.18e3,
                    "r3" : 81.818e3,
                    "r4" : 818.18e3,
                    "cF" : 6.31e-13,
                },
                "200": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            8.00e-01,
                            4.40e+04,
                            8.00e+05,
                        ],
                        "zeros": [
                            2.40e+05,
                        ],
                    },
                    "r1" : 81.818e3,
                    "r2" : 818.18e3,
                    "r3" : 81.818e3,
                    "r4" : 818.18e3,
                    "cF" : 6.31e-13,
                },
                "150": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            8.00e-01,
                            4.40e+04,
                            8.00e+05,
                        ],
                        "zeros": [
                            2.40e+05,
                        ],
                    },
                    "r1" : 81.818e3,
                    "r2" : 818.18e3,
                    "r3" : 81.818e3,
                    "r4" : 818.18e3,
                    "cF" : 6.31e-13,
                },
                "100": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            1.20e+00,
                            7.94e+05,
                        ],
                        "zeros": [
                            2.40e+05,
                        ],
                    },
                    "r1" : 81.818e3,
                    "r2" : 818.18e3,
                    "r3" : 81.818e3,
                    "r4" : 818.18e3,
                    "cF" : 6.31e-13,
                },
                "80": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            1.20e+00,
                            7.94e+05,
                        ],
                        "zeros": [
                            2.40e+05,
                        ],
                    },
                    "r1" : 81.818e3,
                    "r2" : 818.18e3,
                    "r3" : 81.818e3,
                    "r4" : 818.18e3,
                    "cF" : 6.31e-13,
                },
                "40": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            7.59e-02,
                            4.37e+04,
                            1.00e+05,
                            2.00e+05,
                        ],
                        "zeros": [
                            1.66e+05,
                        ],
                    },
                    "r1" : 300e3,
                    "r2" : 600e3,
                    "r3" : 300e3,
                    "r4" : 600e3
                },
                "20": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            7.59e-02,
                            4.37e+04,
                            1.00e+05,
                            2.00e+05,
                        ],
                        "zeros": [
                            1.66e+05,
                        ],
                    },
                    "r1" : 300e3,
                    "r2" : 600e3,
                    "r3" : 300e3,
                    "r4" : 600e3
                },
                "10": {
                    "openLoopGain": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Db, Degrees",
                        "dcGain": 120,
                        "poles": [
                            1.05e-01,
                            9.12e+03,
                            2.40e+04,
                            5.01e+04,
                        ],
                        "zeros": [
                            2.00e+04,
                            2.29e+04,
                        ],
                    },
                    "r1" : 300e3,
                    "r2" : 600e3,
                    "r3" : 300e3,
                    "r4" : 600e3
                }
            },
        }
    }
}